import Axios from "../BaseAxios";
import { API_CLIENT_URL, ROUTER_URL } from "../../constants/urls";
import Keys from "../../constants/keys";
import store from "../../store";
import authToken from "../../common/authToken";
import PaymentApiHelper from "../common/PaymentApis";
import router from "../../router";
import AmplitudeHelper from "../../amplitude";

const UserApiHelper = {
  getUserMembershipDetails(
    id = null,
    fnSuccessResponse = null,
    fnFailureResponse = null
  ) {
    var requestParams = {
      id: id,
    };

    Axios.request_GET(
      API_CLIENT_URL.userMembershipDetails,
      requestParams,
      {},
      fnSuccessResponse,
      fnFailureResponse,
      false
    );
  },
  makeMembershipOrderId(workshopId, plan, firstName, lastName, email, mobile) {
    store.state.workshop.buttonLoading = true;
    let successHandler = (res) => {
      console.log(res);
      this.initiateMembershipPayment(
        res.data.transaction_id,
        res.data.id,
        firstName + " " + lastName,
        email,
        mobile,
        workshopId
      );
      store.state.workshop.buttonLoading = false;
      store.state.webinar.buttonLoading = false;
      store.state.workshop.singleWorkshopBtnLoading = false;
    };

    const failureHandler = (res) => {
      store.state.workshop.buttonLoading = false;
      store.state.webinar.buttonLoading = false;
      store.state.workshop.singleWorkshopBtnLoading = false;
      store.state.workshop.buttonLoading = false;
      console.log(res);
    };

    var requestParams = {};
    requestParams[Keys.WORKSHOP_ID] = workshopId;
    requestParams[Keys.MEMBERSHIP_PLAN_ID] = plan.id;

    requestParams[Keys.FIRST_NAME] = firstName;
    requestParams[Keys.LAST_NAME] = lastName;
    requestParams[Keys.EMAIL] = email;
    requestParams[Keys.MOBILE] = mobile;

    requestParams[Keys.SOURCE] = store.state.userUTM.utm_source;
    requestParams[Keys.MEDIUM] = store.state.userUTM.utm_medium;
    requestParams[Keys.CAMPAIGN] = store.state.userUTM.utm_campaign;

    PaymentApiHelper.getMembershipPaymentOrderId(
      requestParams,
      successHandler,
      failureHandler
    );
  },
  initiateMembershipPayment(
    transaction_id,
    order_id,
    name = null,
    email = null,
    mobile = null,
    workshopId = null
  ) {
    store.state.payment.transactionId = transaction_id;
    const paymentSuccessHandler = (res) => {
      console.log("razorPay Response:", res);

      this.verifyMembershipPayment(
        res.razorpay_payment_id,
        res.razorpay_order_id,
        res.razorpay_signature,
        workshopId
      );
    };

    const paymentFailureHandler = (res) => {
      console.log(res);
      store.state.workshop.buttonLoading = false;
    };

    PaymentApiHelper.initiatePayment(
      transaction_id,
      store.state.membership.selectedMembership.price,
      "Eblity Membership",
      store.state.membership.selectedMembership.name,
      order_id,
      paymentSuccessHandler,
      paymentFailureHandler,
      store.state.membership.selectedMembership.currency_details.name,
      name,
      email,
      mobile
    );
  },
  verifyMembershipPayment(
    razorpay_payment_id,
    razorpay_order_id,
    razorpay_signature,
    workshopId = null
  ) {
    store.state.workshop.buttonLoading = true;
    const paymentVerifySuccessHandler = (res) => {
      console.log(res);

      // if (workshopId) {
      //   AmplitudeHelper.registerAmplitudeEvent(
      //     "workshop membership registration success",
      //     {
      //       "workshop name": store.state.sessionSeriesDetails.data.title,
      //     }
      //   );
      // }

      // //Thank You Page or Watch Webinar (in case of on-demand)
      // if (store.state.sessionSeriesDetails.data.status == "On-Demand") {
      //   router.push({
      //     name: ROUTER_URL.publicSession.children.sessionOnDemandDetails.name,
      //   });
      // } else {
      //   router.push({
      //     name: ROUTER_URL.publicSession.children.sessionThankYou.name,
      //   });
      // }

      var param = {};
      var userProperty = {};

      if (store.state.sessionSeriesDetails.data) {
        param = {
          "workshop name": store.state.sessionSeriesDetails.data.title,
        };
      }

      if (store.state.isMembershipEnabled) {
        if (authToken.decodedToken().membership_validity ? false : true) {
          param["membership type"] = "new";
        } else {
          param["membership type"] = "renewal";
        }

        userProperty["membership type"] = "Eblity Member";
      } else {
        userProperty["membership type"] = "Premium Member";
      }

      AmplitudeHelper.setUserProperty(userProperty);

      AmplitudeHelper.registerAmplitudeEvent("new membership success", param);

      store.state.membership.userMembership = res.data.data;
      localStorage.setItem("token", res.data.token);

      authToken.deleteCookie(`accesstoken`);

      document.cookie = `accesstoken=${res.data.token}; domain=.eblity.com`;

      if (res.data.data.is_preferences_set) {
        router.push({
          name: ROUTER_URL.publicMembership.children.membershipThankYou.name,
        });
      } else {
        router.push({
          name: ROUTER_URL.publicUser.children.preferences.name,
        });
      }
    };

    const paymentVerifyFailureHandler = (res) => {
      console.log(res);
      store.state.workshop.buttonLoading = false;
    };

    PaymentApiHelper.verifyPayment(
      razorpay_payment_id,
      razorpay_order_id,
      razorpay_signature,
      store.state.payment.transactionId,
      paymentVerifySuccessHandler,
      paymentVerifyFailureHandler
    );
  },
};

export default UserApiHelper;
